import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";
import styles from "./TransactionBarChart.module.scss";
import { convertApiDate } from "../../util/DateUtil";

export default function TransactionBarChart({ data, identifier }: any) {
  return (
    <div
      style={{ padding: "20px", marginLeft: "-40px" }}
      className={styles.container}
    >
      <ResponsiveContainer width="90%" height={250}>
        <BarChart
          width={500}
          height={250}
          data={data}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
          barSize={18}
          barGap={3}
          layout="horizontal"
        >
          <XAxis
            dataKey={`${identifier}`}
            scale="point"
            padding={{ left: 50, right: 10 }}
          />
          <YAxis dataKey="total" axisLine={false} tickLine={false} />
          <Tooltip />

          <CartesianGrid strokeDasharray="0 0" vertical={false} />
          <Bar
            dataKey="success"
            fill="#16A33F"
            // background={{ fill: "#ffffff" }}
          />
          <Bar
            dataKey="failed"
            fill="#EB5757"
            // background={{ fill: "#ffffff" }}
            // barSize={19}
          />
          <Bar dataKey="pending" fill="#E8BB00" />
          {/* <Legend
            width={100}
            wrapperStyle={{
              top: 0,
              right: 0,
              backgroundColor: "transparent",
              lineHeight: "15px",
            }}
          /> */}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
